import Layout from "../../../components/custom/Layout";

export default function SharedPasswords () {
    return (
        <Layout>
            <h4>Shared Passwords</h4>
            <h6>You have access to create/update/assign Shared Passwords in EOS Vault.</h6>
        </Layout>
    );
}
